module.exports = __webpack_public_path__ + "img/picture_06_portada.713273d9.png";